const translations = {
  "notifications.passwordChanged": "პაროლი წარმატებით შეიცვალა!",
  "notifications.passwordCouldntChange": "პაროლის შეცვლა ვერ მოხერხდა",
  "notifications.passwordIsWrong": "მომხმარებლის პაროლი არასწორია",
  "notifications.consultationDeleted": "კონსულტაცია წარმატებით წაიშალა",
  "notifications.consultationCouldntBeDeleted": "კონსულტაცია ვერ გაუქმდა",
  "notifications.couldntFindActivePolicy":
    "სამწუხაროდ, აღნიშნული პირადი ნომრით აქტიური პოლისი ვერ მოიძებნა",
  "notifications.wrongInsuranceNumber": "დამზღვევის პირადი ნომერი არასწორია",
  "notifications.couldntGetInfo": "ინფორმაციის წამოღება ვერ მოხერხდა",
  "notifications.inputCorrectPNOrBdate": `სამწუხაროდ, შვილის დამატება შეუძლებელია. 
    შესაძლებელია მხოლოდ იმ პირის დამატება, რომლის ასაკიც არ აღემატება 14 წელს`,
  "notifications.wrongUserName": "პაროლი/მომხმარებლის სახელი არასწორია",
  "notifications.successfullyCanceled": "კონსულტაცია წარმატებით გაუქმდა",
  "notifications.couldntCancelConsultation": "კონსულტაცია ვერ გაუქმდა",
  "notifications.informationSuccessfullyShared":
    "ინფორმაცია წარმატებით გაზიარდა",
  "notifications.couldntshareDetails": "ინფორმაციის გაზიარება ვერ მოხერხდა",
  "notifications.verificationCodeIsWrong": "ვერიფიკაციის კოდი არასწორია",
  "notifications.sesssionExpired":
    "სესიას გაუვიდა ვადა, გთხოვ დაბრუნდე SMS ავტორიზაციის ეტაპზე",
  "notifications.phoneChangedSuccessfully":
    "ტელეფონის ნომერი წარმატებით შეიცვალა",
  "notifications.couldntRegister":
    "ბოდიშს გიხდით რეგისტრაცია დროებით შეუძლებელია",
};

export default translations;
